export default {
  // 用户操作
  login(_this, param, next, err) { // 登录
    _this.$axios.post('/login', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  /** 角色管理 */
  rolePage(_this, param, next, err) { // 查询角色
    _this.$axios.post('/sysRole/page', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  roleSave(_this, param, next, err) { // 保存角色
    _this.$axios.post('/sysRole/save', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  roleDelete(_this, param, next, err) { // 删除角色
    _this.$axios.post('/sysRole/delete', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  roleAuth(_this, param, next, err) { // 角色权限
    _this.$axios.post('/sysRole/roleMenus', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  roleAuthLeaves(_this, param, next, err) { // 角色权限(排除父节点)
    _this.$axios.post('/sysRole/roleMenusLeaves', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  saveAuth(_this, param, next, err) { // 保存角色权限
    _this.$axios.post('/sysRole/saveAuth', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  /** 菜单管理 */
  menuSave(_this, param, next, err) { // 保存菜单
    _this.$axios.post('/sysMenu/save', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  menuDelete(_this, param, next, err) { // 删除菜单
    _this.$axios.post('/sysMenu/delete', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  menuTree(_this, param, next, err) { // 菜单树
    _this.$axios.get('/sysMenu/tree', param).then(res => {
      next(res);
    })
  },
  /** 用户管理 */
  checkAccountExist(_this, param, next, err) { // 查询账号是否已注册
    _this.$axios.post('/sysUser/checkAccountExist', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  checkPhoneExist(_this, param, next, err) { // 查询手机号是否已注册
    _this.$axios.post('/sysUser/checkPhoneExist', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  accountDelete(_this, param, next, err) { // 删除用户
    _this.$axios.post('/sysUser/delete', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  accountForbidden(_this, param, next, err) { // 禁用账号
    _this.$axios.post('/sysUser/forbidden', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  accountPage(_this, param, next, err) { // 系统用户分页查询
    _this.$axios.post('/sysUser/page', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  accountSave(_this, param, next, err) { // 添加/修改账号信息
    _this.$axios.post('/sysUser/save', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  checkAndUpdateMyPwd(_this, param, next, err) { // 修改密码
    _this.$axios.post('/sysUser/checkAndUpdateMyPwd', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  resetPwd(_this, param, next, err) { // 修改密码
    _this.$axios.post('/sysUser/updatePwd', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  /** 品牌管理 */
  brandPage(_this, param, next, err) { //品牌列表(分页)
    _this.$axios.post('/brand/findPage', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  brandDelete(_this, param, next, err) { //品牌删除
    _this.$axios.post('/brand/delete', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  brandSave(_this, param, next, err) { //品牌保存
    _this.$axios.post('/brand/save', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },

  /** 分类管理 */
  categoryPage(_this, param, next, err) { //分类列表(分页)
    _this.$axios.post('/category/findPage', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  categoryDelete(_this, param, next, err) { //分类删除
    _this.$axios.post('/category/delete', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  categorySave(_this, param, next, err) { //分类保存
    _this.$axios.post('/category/save', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
   /** 系统日志 */

  queryTables(_this, param, next, err) { //数据库表格分页查询
    _this.$axios.post('/generator/queryTables', param).then(res => {
      next(res);
    }).catch(er => {
      err(er)
    })
  },
  searchMessageByID(_this, param, next, err) { // 根据id查询消息
    _this.$axios.get('/InfoManage/SearchMessageByID', param).then(res => {
      next(res);
    })
  },
  getLatestTopNews(_this, param, next, err) { // 获取最新头条信息
    _this.$axios.get('/InfoManage/GetLatestTopNews', param).then(res => {
      next(res);
    })
  },
    /** 定时任务 */
  jobDelete(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/delete', param).then(res => {
          next(res);
      })
  },
  jobInfo(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/info', param).then(res => {
          next(res);
      })
  },
  jobPage(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/page', param).then(res => {
          next(res);
      })
  },
  jobPause(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/pause', param).then(res => {
          next(res);
      })
  },
  jobResume(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/resume', param).then(res => {
          next(res);
      })
  },
  jobRun(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/run', param).then(res => {
          next(res);
      })
  },
  jobSave(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/save', param).then(res => {
          next(res);
      })
  },
  jobUpdate(_this, param, next, err) { // 定时任务
      _this.$axios.post('/job/update', param).then(res => {
          next(res);
      })
  },
  findJobLog(_this, param, next, err) { // 任务日志
      _this.$axios.post('/jobLog/page', param).then(res => {
          next(res);
      })
  },
  errorLogPage(_this, param, next, err) { //错误日志
      _this.$axios.post('/errorLog/page', param).then(res => {
          next(res);
      }).catch(er => {
          err(er)
      })
  },
  /** 平台配置 */
  platformConfigPage(_this, param, next, err) { // 平台配置列表
      _this.$axios.post('/sysDic/page', param).then(res => {
          next(res);
      })
  },
  platformConfigSave(_this, param, next, err) { // 平台配置跟新
      _this.$axios.post('/sysDic/save', param).then(res => {
          next(res);
      })
  },
  findSignUpImportLog(_this, param, next, err) { // 考级导入日志
    _this.$axios.post('/CsSignUp/importExcelLog', param).then(res => {
      next(res);
    })
  },
  CsExamineeImportIdFileZipLog(_this, param, next, err) { //证照导入日志
    _this.$axios.post('/CsExaminee/importIdFileZipLog', param).then(res => {
      next(res);
    })
  }
}
